import { render, staticRenderFns } from "./bookIndex.vue?vue&type=template&id=cecc5e6a&scoped=true&"
import script from "./bookIndex.vue?vue&type=script&lang=js&"
export * from "./bookIndex.vue?vue&type=script&lang=js&"
import style0 from "./bookIndex.vue?vue&type=style&index=0&id=cecc5e6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecc5e6a",
  null
  
)

export default component.exports